import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";
import "dayjs/locale/ja";
dayjs.locale("ja");

export default {
  name: "approval",
  components: {
    AppHeader
  },
  async created() {
    await this.getAttendanceApprovals();
    await this.getLeaveApprovals();
    await this.getOverTimeApprovals();
    this.allGetEnd = true;
  },
  data() {
    return {
      approvalAttendanceCount: "",
      approvalLeaveCount: "",
      approvalAttendances: {},
      getApprovalAttendancesEnd: false,
      approvalLeaves: [],
      getApprovalLeavesEnd: false,
      approvalOvertimes: [],
      approvalOvertimeCount: "",
      getApprovalOvertimesEnd: false,
      allGetEnd: false,
      forRejectionAttendanceId: "",
      forApprovalAttendanceId: "",
      forApprovalAttendanceAllId: "",
      forApprovalAttendanceAllDate: "",
      forRejectionLeaveId: "",
      forApprovalLeaveId: "",
      forApprovalOvertimeId: "",
      savingFlag: false
    };
  },
  computed: {
    isSasaki() {
      if (localStorage.user_id == 59) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async getAttendanceApprovals() {
      this.savingFlag = false;
      let data = {
        approval_type: ""
      };
      let res = await this.$store
        .dispatch("GET_APPROVAL_ATTENDANCE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.approvalAttendances = res.approval_attendances;
      this.approvalAttendanceCount = res.approval_count;
      this.getApprovalAttendancesEnd = true;
    },
    async getLeaveApprovals() {
      this.savingFlag = false;
      let data = {
        approval_type: ""
      };
      let res = await this.$store
        .dispatch("GET_APPROVAL_LEAVE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.approvalLeaves = res.approval_leaves;
      this.approvalLeaveCount = res.approval_count;
      this.getApprovalLeavesEnd = true;
    },
    async getOverTimeApprovals() {
      this.savingFlag = false;
      let data = {
        approval_type: ""
      };
      let res = await this.$store
        .dispatch("GET_APPROVAL_OVERTIME", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.approvalOvertimes = res.approval_overtimes;
      this.approvalOvertimeCount = res.approval_count;
      this.getApprovalOvertimesEnd = true;
    },
    formatAttendanceDate(date) {
      return dayjs(date).format("YYYY年MM月DD日(ddd)");
    },
    async goAttendanceDateDetailApproval(userId, attendanceDate) {
      this.$router.push(
        `/attendance/${userId}/user/${attendanceDate}/approval`
      );
    },
    async forceApprovalRejection() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = {
        attendance_id: this.forRejectionAttendanceId
      };
      await this.$store
        .dispatch("FORCE_APPROVAL_REJECTION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.getAttendanceApprovals();
    },
    async setApprovalAttendance() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = {
        attendance_id: this.forApprovalAttendanceId
      };
      await this.$store
        .dispatch("SET_APPROVAL_ATTENDANCE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.getAttendanceApprovals();
    },
    async setApprovalAttendanceAll() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = {
        attendance_id: this.forApprovalAttendanceAllId
      };
      await this.$store
        .dispatch("SET_APPROVAL_ATTENDANCE_ALL", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.getAttendanceApprovals();
    },
    async forceLeaveRejection() {
      if (this.savingFlag) return;
      this.savingFlag = true;
      let data = {
        attendance_id: this.forRejectionLeaveId
      };
      await this.$store
        .dispatch("FORCE_APPROVAL_REJECTION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.getLeaveApprovals();
    },
    async setApprovalLeaves() {
      if (this.savingFlag) return;
      this.savingFlag = true;
      let data = {
        attendance_id: this.forApprovalLeaveId
      };
      await this.$store
        .dispatch("SET_APPROVAL_LEAVE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.getLeaveApprovals();
    },
    async setApprovalOvertime() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = {
        attendance_id: this.forApprovalOvertimeId
      };
      await this.$store
        .dispatch("SET_APPROVAL_OVERTIME", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.getOverTimeApprovals();
    },
    goRejection(attendanceId) {
      this.$bvModal.show("modal-confirm-absence");
      this.forRejectionAttendanceId = attendanceId;
    },
    goApprovalAttendance(attendanceId) {
      this.$bvModal.show("modal-confirm");
      this.forApprovalAttendanceId = attendanceId;
    },
    goApprovalAttendanceAll(attendanceId, attendanceDate) {
      this.$bvModal.show("modal-confirm-all");
      this.forApprovalAttendanceAllId = attendanceId;
      this.forApprovalAttendanceAllDate = attendanceDate;
    },
    goApprovalLeaveRejection(attendanceId) {
      this.$bvModal.show("modal-ab-confirm-reject");
      this.forRejectionLeaveId = attendanceId;
    },
    goApprovalLeave(attendanceId) {
      this.$bvModal.show("modal-ab-confirm");
      this.forApprovalLeaveId = attendanceId;
    },
    goApprovalOvertime(attendanceId) {
      this.$bvModal.show("modal-confirm-overtime");
      this.forApprovalOvertimeId = attendanceId;
    }
  }
};
